import { render, staticRenderFns } from "./sales-force-informations.vue?vue&type=template&id=5653e1a4"
import script from "./sales-force-informations.vue?vue&type=script&lang=ts"
export * from "./sales-force-informations.vue?vue&type=script&lang=ts"
import style0 from "./sales-force-informations.vue?vue&type=style&index=0&id=5653e1a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
